import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeletePipelineMutation} from '../hooks/usePipelinesQuery';
import {usePipelinesSelection} from "../hooks/usePipelinesSelection.ts";


export const DeleteRecordButton = () => {

    const deletePipelineMutation = useDeletePipelineMutation();

    const {
        selection,
        handleClearSelection,
    } = usePipelinesSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deletePipelineMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
